export default defineNuxtPlugin({
    dependsOn: ['nuxt-site-config:init'],
    setup() {
        const config = useRuntimeConfig()

        updateSiteConfig({
            name: 'YourService Business',
            url: config.public.frontUrl,
        })
    },
})
